import {
  parseToMs,
  formatRemainingCountdown,
  getBaselineRemainingMs,
  computeRemainingPercent,
  computeProgressValue,
  getSlaProgressBarColor,
  getSlaCountdownTextColor
} from '@/shared/utils/sla-deadline-countdown'

export default {
  name: 'sla-deadline-countdown',
  props: {
    deadline: {
      type: [String, Date],
      default: null
    },
    openingDateAt: {
      type: [String, Date],
      default: null
    },
    horizontal: {
      type: Boolean,
      default: true
    }
  },
  data () {
    return {
      tick: 0,
      intervalId: null,
      baselineRemainingMs: null
    }
  },
  computed: {
    deadlineMs () {
      return parseToMs(this.deadline)
    },
    openingMs () {
      return parseToMs(this.openingDateAt)
    },
    now () {
      // Depend on tick so the countdown refreshes every second
      void this.tick
      return Date.now()
    },
    variant () {
      if (this.deadlineMs == null) return 'no-deadline'
      if (this.now >= this.deadlineMs) return 'expired'
      return 'active'
    },
    remainingPercent () {
      if (this.deadlineMs == null) return 0
      return computeRemainingPercent(this.now, this.deadlineMs, this.openingMs)
    },
    progressValue () {
      if (this.deadlineMs == null) return 0
      return computeProgressValue({
        now: this.now,
        deadlineMs: this.deadlineMs,
        openingMs: this.openingMs,
        baselineRemainingMs: this.baselineRemainingMs
      })
    },
    barColor () {
      return getSlaProgressBarColor(this.remainingPercent)
    },
    textColor () {
      return getSlaCountdownTextColor(this.remainingPercent)
    },
    label () {
      if (this.variant === 'expired') {
        return this.$t('physician_sla.deadline_expired')
      }
      if (this.variant === 'active') {
        return formatRemainingCountdown(Math.max(0, this.deadlineMs - this.now))
      }
      return ''
    },
    rootClass () {
      return {
        'sla-deadline-countdown--horizontal': this.horizontal,
        'sla-deadline-countdown--vertical': !this.horizontal
      }
    },
    trackStyle () {
      if (this.variant === 'expired') {
        return { borderColor: '#FC4E69' }
      }
      return {}
    },
    indicatorStyle () {
      return {
        width: `${this.progressValue}%`,
        backgroundColor: this.barColor
      }
    }
  },
  watch: {
    deadline: {
      immediate: true,
      handler () {
        this.resetBaseline()
        this.restartInterval()
      }
    }
  },
  beforeDestroy () {
    this.clearInterval()
  },
  methods: {
    resetBaseline () {
      const deadlineMs = parseToMs(this.deadline)
      this.baselineRemainingMs = getBaselineRemainingMs(deadlineMs, Date.now())
    },
    restartInterval () {
      this.clearInterval()
      const deadlineMs = parseToMs(this.deadline)
      if (deadlineMs == null || Date.now() >= deadlineMs) return

      this.intervalId = window.setInterval(() => {
        this.tick += 1
        if (Date.now() >= deadlineMs) {
          this.clearInterval()
        }
      }, 1000)
    },
    clearInterval () {
      if (this.intervalId != null) {
        window.clearInterval(this.intervalId)
        this.intervalId = null
      }
    }
  }
}
